<template>
  <span>
    <span v-if="!editable">{{ time }}</span>
    <v-menu
      v-else
      :disabled="!editable"
      v-model="repairtimeShowMenu[item.id]"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn
          text
          v-on="on"
          @click="
            repairtimeTmp =
              item.overridden && item.overridden.time_overridden >= 0
                ? item.overridden.time_overridden
                : item.time
          "
        >
          <v-icon x-small>$pencil</v-icon>{{ time }}
        </v-btn>
      </template>
      <v-card :loading="savingInProgress">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <h4>{{ $t("viewRepairtimeeTree.repairtimes") }}</h4>
              <v-text-field
                :placeholder="$t('viewRepairtimeeTree.hours')"
                v-model="repairtimeTmp"
                :disabled="savingInProgress"
                required
                type="numeric"
                :rules="[
                  (v) =>
                    !!((v) => 0) ||
                    $t('form.validationErrors.must_be_greater_or_equal'),
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                @keyup.enter.stop="overrideRepairtime(item, repairtimeTmp)"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="repairtimeShowMenu[item.id] = false"
            v-show="!savingInProgress"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            text
            color="warning"
            @click="overrideRepairtime(item, null)"
            v-show="!savingInProgress && item.overridden"
          >
            {{ $t("viewRepairtimeeTree.reset_to", [item.time]) }}
          </v-btn>
          <v-btn
            v-show="!savingInProgress"
            color="green"
            text
            @click="overrideRepairtime(item, repairtimeTmp)"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </span>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "RepairtimeTreeOverrideTime",
  props: {
    item: {
      type: Object,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    repairtimeShowMenu: {},
    repairtimeTmp: null,
  }),
  computed: {
    ...mapFields("repairtimes", [
      "fetched",
      "repairtimes",
      "repairtimetypes",
      "currentRepairTimeType",
      "savingInProgress",
    ]),
    /**
     * Возврашает time или time_overridden
     * @return Number
     */
    time() {
      if (
        this.item.overridden &&
        this.item.overridden.time_overridden === null
      ) {
        return this.item.time;
      } else {
        return this.item.overridden && this.item.overridden.time_overridden >= 0
          ? this.item.overridden.time_overridden
          : this.item.time;
      }
    },
  },
  methods: {
    async overrideRepairtime(item, time) {
      if (!item.overridden) item.overridden = {};
      item.overridden.time_overridden = time;
      return await this.$store
        .dispatch("repairtimes/overrideRepairtime", item)
        .then((updated) => {})
        .finally(() => {
          this.repairtimeShowMenu[item.id] = false;
        });
    },
  },
};
</script>

<style scoped></style>
